import request from '@/utils/request'
import host from '@/api/base/host'

// 课程练习题
const goodsCourse = host.path('dev', { dev: 'v1/user/exercise' })

export function questionView(data) {
  return request({
    url: goodsCourse('question/view'),
    method: 'post',
    data
  })
}

export function saveQuestions(data) {
  return request({
    url: goodsCourse('question'),
    method: 'post',
    data
  })
}
